import { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useFocusable, FocusContext, setFocus } from '@dstv-web-leanback/norigin-spatial-navigation'

import styles from './SectionMenu.module.scss'
import { SectionNavItem } from '@dstv-web-leanback/dstv-frontend-components'
import { SET_ACTIVE_SECTION, useNavigation } from '@dstv-web-leanback/dstv-frontend-services'

export function SectionMenu({ gridFocused, onSectionChange, handleArrow }) {
	const sectionsState = useSelector((state) => state.sections)
	const [menuScroll, setMenuScroll] = useState(0)
	const [showGenreSectionOverlay, setShowGenreSectionOverlay] = useState(!gridFocused && sectionsState.data?.length)
	const { location } = useNavigation()

	const dispatch = useDispatch()
	const wrapperRef = useRef()

	useEffect(() => {
		if (!location.back) {
			setMenuScroll(0)
			setFocus('SUBMENU_0')
		}
	}, [sectionsState.data, location.back])

	const { focusKey, ref } = useFocusable({
		focusKey: 'SECTION_MENU',
		preferredChildFocusKey: `SUBMENU_${sectionsState.activeSection}`,
		saveLastFocusedChild: false,
	})

	const showOrHideGenreSectionOverlay = (scrolledMenuWidthDiff) => {
		const wrapperStyles = getComputedStyle(wrapperRef.current)
		setShowGenreSectionOverlay(Number.parseFloat(wrapperStyles.width) < scrolledMenuWidthDiff)
	}

	const changeMenuFocus = (index, focusedRef) => {
		let menuStyles = getComputedStyle(ref.current)
		const menuScrollWidth = focusedRef.current.offsetLeft - Number.parseInt(menuStyles.paddingLeft)
		setMenuScroll(menuScrollWidth)
		dispatch(SET_ACTIVE_SECTION({ index: index }))
		onSectionChange && onSectionChange(index)
		showOrHideGenreSectionOverlay(Number.parseFloat(menuStyles.width) - menuScrollWidth)
	}

	return (
		<FocusContext.Provider value={focusKey}>
			<div ref={wrapperRef} className={`${styles.section_menu_wrapper} ${gridFocused && styles.hidden}`}>
				{showGenreSectionOverlay && <div className={styles.shadow}></div>}
				<div ref={ref} className={styles.section_menu} style={{ transform: `translate3d(-${menuScroll}px, 0, 0)` }}>
					{sectionsState?.data?.map((item, index) => {
						return (
							<SectionNavItem
								active={index === sectionsState.activeSection}
								id={item.id}
								index={index}
								itemFocus={changeMenuFocus}
								key={index}
								title={item.title}
								handleArrow={handleArrow}
							/>
						)
					})}
				</div>
			</div>
		</FocusContext.Provider>
	)
}

export default SectionMenu
